import script from "./PostMeta.vue?vue&type=script&setup=true&lang=js"
export * from "./PostMeta.vue?vue&type=script&setup=true&lang=js"

import "./PostMeta.vue?vue&type=style&index=0&id=1d747702&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d747702"]])

export default __exports__